import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContratoTipoAssinaturaComponent } from './contrato-tipo-assinatura.component';

@NgModule({
  declarations: [
    ContratoTipoAssinaturaComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    ContratoTipoAssinaturaComponent
  ],
})
export class ContratoTipoAssinaturaModule { }
